import { render } from "./InlineLoader.vue?vue&type=template&id=f6aa4a0e&scoped=true"
import script from "./InlineLoader.vue?vue&type=script&lang=js"
export * from "./InlineLoader.vue?vue&type=script&lang=js"

import "./InlineLoader.vue?vue&type=style&index=0&id=f6aa4a0e&scoped=true&lang=css"

import exportComponent from "/home/glassplant/agi.co.jp/roots-prod/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6aa4a0e"]])

export default __exports__